import api from './authService';

export const supportChatApi = {
  getStatus: async () => {
    const response = await api.get('/support-chat/status');
    return response.data;
  },

  sendMessage: async ({ message, history, signal }) => {
    const response = await api.post(
      '/support-chat/message',
      { message, history },
      { signal, timeout: 90000 }
    );
    return response.data;
  },
};

export const guestConciergeApi = {
  getStatus: async () => {
    const response = await api.get('/public/support-chat/status');
    return response.data;
  },

  sendMessage: async ({ message, history, hints, signal }) => {
    const response = await api.post(
      '/public/support-chat/message',
      { message, history, hints },
      { signal, timeout: 90000 }
    );
    return response.data;
  },
};
